import Grid from 'material-ui/Grid';
import loader from '../assets/searching.gif';
import styled from 'styled-components';

export const App = styled.div`
  overflow: hidden;
  height: ${props => props.wh};
  width: 100%;

  &.desktop {
    @media (orientation: landscape) {
      height: 100vh;
    }
  }
`;
export const DownloadMessage = styled.div`
  font-family: 'canada-type-gibson';
  font-weight: 400;
  font-size: 21px;
`;
export const Map = styled(Grid) `
  position: relative;
  z-index: 200;

  @media (orientation: portrait) {
    width: 100%;
  }
  @media (max-width: 599px) and (orientation: portrait) {
    height: calc(${props => props.wh} - ${props => props.searchheight});
  }
  // @media (max-width: 599px) and (min-height: 630px) and (orientation: portrait) {
  //   height: calc(100% - 420px);
  // }
  // @media (max-width: 599px) and (min-height: 660px) and (orientation: portrait) {
  //   height: calc(100% - 440px);
  // }
  @media (min-width: 600px) and (orientation: portrait) {
    height: calc(100% - 420px);
  }
  @media (min-width: 600px) and (min-height: 630px) and (orientation: portrait) {
    height: calc(100% - 440px);
  }
  @media (min-width: 600px) and (min-height: 660px) and (orientation: portrait) {
    height: calc(100% - 460px);
  }
  @media (min-width: 960px) and (orientation: portrait) {
    height: calc(100% - 542px);
  }
  &.init {
    @media (min-width: 600px)  and (orientation: portrait) {
      height: calc(50% - 80px);
    }
    // @media (min-width: 600px) and (orientation: portrait) {
    //   transform: translateY(calc(50% - 80px));
    // }
    // @media (min-width: 600px) and (min-height: 660px) and (orientation: portrait) {
    //   transform: translateY(calc(50% - 100px));
    // }
    // @media (min-width: 600px) and (min-height: 660px) and (orientation: portrait) {
    //   transform: translateY(calc(50% - 120px));
    // }
  }
  
  @media (min-height: 320px) and (orientation: landscape) {
    float: left;
    width: 50%;
    height: 100%;
  }
  @media (min-width: 700px) and (orientation: landscape) {
    width: 58.33333%;
  }
  @media (min-width: 960px) and (orientation: landscape) {
    height: calc(100% - 62px);
    z-index: 200;
  }
  @media (min-width: 1920px) and (orientation: landscape) {
    width: 66.66667%;
    height: calc(100% - 62px);
  }
`;
export const SearchResults = styled.div`
  position: relative;
  z-index: 251;
  background: rgba(254,219,151,1);

  @media (orientation: portrait) {
    width: 100%;
    transform: translateY(0);
    transition: all 0.5s ease-in;
  }
  @media (max-width: 599px) and (orientation: portrait) {
    height: 100%;
    transform: translateY(calc(100vh - 300px - 100vh));
  }
  @media (max-width: 599px) and (min-height: 630px) and (orientation: portrait) {
    transform: translateY(calc(100vh - 320px - 100vh));
  }
  @media (max-width: 599px) and (min-height: 660px) and (orientation: portrait) {
    transform: translateY(calc(100vh - 340px - 100vh));
  }
  @media (min-width: 600px) and (orientation: portrait) {
    height: 420px;
  }
  @media (min-width: 600px) and (min-height: 630px) and (orientation: portrait) {
    height: 440px;
  }
  @media (min-width: 600px) and (min-height: 660px) and (orientation: portrait) {
    height: 460px;
  }
  
  &.init {
    height: 80px;
    @media (max-width: 599px) and (orientation: portrait) {
      transform: translateY(0);
    }
    @media (min-width: 600px) and (orientation: portrait) {
      transform: translateY(0);
      height = calc(50% + 80px);
    }
    // @media (min-width: 600px) and (min-height: 630px) and (orientation: portrait) {
    //   translateY(calc(50% - 100px))
    // }
    // @media (min-width: 600px) and (min-height: 660px) and (orientation: portrait) {
    //   translateY(calc(50% - 120px))
    // }
    // @media (min-width: 960px) and (orientation: portrait) {
      // transform: translateY(-192px);
    // }
  }
  @media (max-width: 599px) and (orientation: portrait) {
    
    &.shrink {
      transform: translateY(0);
    }
    &.isOpen {
      background-color: rgba(254,219,151,1);

      &.device {
        // transform: translateY(calc(${props => props.wh} + 70px));
        // transform: translateY(${props => props.keyboardTranslate});
        transform: translateY(0);
        height: 70px;
      }
    }
  }

  @media (min-height: 320px) and (orientation: landscape) {
    margin-left: 50%;
    width: 50%;
    height: 100%;

    &.init {
      height: 80px;
    }
  }
  @media (min-width: 700px) and (orientation: landscape) {
    margin-left: 58.33333%;
    width: 41.66667%;
  }
  @media (min-width: 960px) and (orientation: landscape) {
    margin-left: 58.33333%;
    width: 41.66667%;
    height: calc(100% - 62px);
  }
  @media (min-width: 1920px) and (orientation: landscape) {
    margin-left: 66.66667%;
    width: 33.33333%;
  }
`;
export const LogoWrapper = styled.div`
  cursor: pointer;
`;
export const MobileButton = styled.div`
  width: 46px;
  height: 46px;
  position: absolute;
  right: 15px;
  top: 5px;
  margin: 10px auto;
  transform: rotate(0deg);
  transition: all .5s ease-in-out;
  cursor: pointer;
  background: #0066FF;
  border-radius: 50%;
  z-index: 260;

  @media (min-height: 320px) and (orientation: landscape)  {
    display: none;
  }
  // @media (max-device-width: 599px) and (orientation: portrait) {
  //   transform: translateY(${props => props.toolbar});
  // }

  span {
    display: block;
    position: absolute;
    height: 3px;
    width: 40%;
    background: #fff;
    opacity: 1;
    transform: rotate(0deg);
    transition: all .25s ease-in-out;
    left: 14px;
  }
  span:nth-child(1) {
    top: 16px;
  }
  span:nth-child(2), span:nth-child(3) {
    top: 22px;
  }
  span:nth-child(4) {
    top: 28px;
  }
  &.open {
    span:nth-child(1) {
      top: 28px;
      width: 0%;
    }
    span:nth-child(2) {
      transform: rotate(45deg);
    }
    span:nth-child(3) {
      transform: rotate(-45deg);
    }
    span:nth-child(4) {
      top: 28px;
      width: 0%;
    }
  }
`;
export const Header = styled.div`
  background: rgba(254, 219, 151, 1);
  position: relative;
  width: 100%;
  z-index: 20;
  height: 80px;

  @media (min-width: 600px) and (orientation: landscape) {
    position: fixed;
    width: 50%;
    top: 0;
  }
  @media (min-width: 700px) and (orientation: landscape) {
    width: 41.66667%;
  }
  @media (min-width: 1920px) {
    width: 33.33333%;
  }
  @media (orientation: portrait) {
    width: 100%;
    height: 60px;
  }
  @media (min-width: 600px) and (orientation: portrait) {
    height: 80px;
  }
  
`;
export const Search = styled.div`
  padding: 15px;
  position: relative;
  
  @media (min-height: 320px) and (orientation: landscape) {
    padding: 20px;
  }
  @media (min-width: 600px) and (orientation: portrait) {
    padding: 20px;
  }
  > div:first-child {
    width: calc(100% - 40px);
    display: inline-block;
    margin-right: 10px;

    > div {
      position: relative;
    }
  }
  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-top: 2px;
  }
  .searchField {
    width: calc(100% - 40px);
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  input {
    border: 0;
    background: #fff;
    padding: 0 10px;
    margin: 0;
    height: 38px;
    color: #0066FF;
  }
  .icon.search, .icon.clear {
    position: absolute;
    right: 10px;
    top: 8px;
    fill: #999;
    z-index: 2;
    padding: 0 0 0 5px;
    background: #fff;
  }
`;
export const InfoBtn = styled.div`
  position: absolute;
  top: calc(50% - 15px);
  right: 20px;
  cursor: pointer;
  background: #FF9700;
  border-radius: 50%;
  color: #fff;
  width: 30px;
  height: 30px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 21px;
  font-family: 'canada-type-gibson';

  &:hover {
    background: #0066ff;
  }
`;
export const TabArea = styled.div`
  background: #FEEDCB;
  height: 40px;
  position: relative;
  width: 100%;
  z-index: 5;
  top: 0;

  &.with-tabs {
    background: rgba(254,219,151,1);
  }
  @media (min-width: 600px) and (orientation: landscape) {
    position: fixed;
    top: 80px;
    width: 41.66667%;
  }
  @media (min-width: 960px) and (orientation: landscape) {
    width: 41.66667%;
  }
  @media (orientation: portrait) {
    width: 100%;
  }
  @media (min-width: 1920px) {
    width: 33.33333%;
  }
`;
export const TabContainer = styled.div`
  width: 300px;
  height: 40px;
  margin: auto;

  @media (min-width: 600px) and (orientation: portrait) {
    margin: 0;
  }
  @media (min-width: 960px) {
    width: 380px;
  }
  @media (min-width: 1280px) {
    width: 450px;
  }
  .icon {
    display: none;
    position: absolute;
    right: 0px;
    bottom: 11px;
  }
  .active .icon {
    display: inline-block;
  }
`;
export const TabContent = styled.div`
  position: relative;
  height: 100%;
  background: #FEEDCB;
  @media (min-height: 320px) and (orientation: landscape) {
    height: calc(100% - 120px);
    top: 120px;
  }
`;
export const Loader = styled.div`
  // background: rgba(0,102,255,0.7);
  background: rgba(254,219,151,0.7);
  position: absolute;
  z-index: 5;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${props => props.show ? 'translateY(0)' : 'translateY(-35vh)'};

  @media (max-width: 599px) and (orientation: portrait) {
    height: 100vh;
  }
  @media (min-width: 600px) {
    transform: translateY(0);
    // height: calc(100% - 62px);
    // width: 58.33333%;
    height: 100%;
    width: 100%;
  }
`;


// WEBPACK FOOTER //
// ./src/containers/style.js